// extracted by mini-css-extract-plugin
export var ModulePinpointListModuleListItem2o_El = "Footer-module--ModulePinpointList-module--listItem--2o_El--96839";
export var ModulePinpointListModuleToggleIcon2v8cb = "Footer-module--ModulePinpointList-module--toggleIcon--2v8cb--51a02";
export var a = "Footer-module--a--9075e";
export var additionalInfo = "Footer-module--additionalInfo--06fc5";
export var askBotaina = "Footer-module--askBotaina--61517";
export var b = "Footer-module--b--81bf9";
export var balaghText = "Footer-module--balaghText--6c0c5";
export var botaina = "Footer-module--botaina--3fee4";
export var c = "Footer-module--c--5dd2e";
export var community = "Footer-module--community--81677";
export var contactItem = "Footer-module--contactItem--0c035";
export var copyrightWrapper = "Footer-module--copyrightWrapper--682a1";
export var d = "Footer-module--d--d243c";
export var e = "Footer-module--e--2f74c";
export var f = "Footer-module--f--a38c8";
export var footerCopyright = "Footer-module--footerCopyright--0a80a";
export var g = "Footer-module--g--faf0e";
export var gatsbyPluginPageProgress = "Footer-module--gatsby-plugin-page-progress--30e6a";
export var h = "Footer-module--h--ce52a";
export var infoBarWrapper = "Footer-module--infoBarWrapper--a99d3";
export var innerWrapper = "Footer-module--innerWrapper--d81fe";
export var introText = "Footer-module--introText--762d7";
export var links = "Footer-module--links--b661e";
export var mada = "Footer-module--mada--4fa33";
export var markGreen = "Footer-module--markGreen--23ad5";
export var markOrange = "Footer-module--markOrange--bed74";
export var navList = "Footer-module--navList--142a4";
export var p = "Footer-module--p--f9c4d";
export var para = "Footer-module--para--616bb";
export var qfLogo = "Footer-module--qfLogo--97563";
export var smallLinks = "Footer-module--smallLinks--b504c";
export var tapStory = "Footer-module--tap-story--465f9";
export var text = "Footer-module--text--a253b";
export var top = "Footer-module--top--689bf";
export var topArrow = "Footer-module--topArrow--15eb0";
export var wrapper = "Footer-module--wrapper--4664e";